import classNames from "classnames";

import styles from "./Picker.module.css";
import { Button } from "../Button";
import { useContext } from "react";
import UiContext from "../../context/UiContext";

export const Picker = () => {
  const { state, closePicker, openModal } = useContext(UiContext);

  const hasLocaton = state.picker?.selectedLocation !== undefined;

  const handlePlacePin = () => {
    closePicker();
    openModal({ name: "addPin" });
  };

  const pickerClass = classNames({
    [styles.picker]: true,
    [styles["-visible"]]: state?.picker?.isOpen,
  });

  // Picker
  return (
    <div className={pickerClass}>
      <div className={styles.header}>
        <div className={styles["header-inner"]}>
          <p>Dra rundt i kartet for å plassere innspel</p>
          <p>Zoom med kniperørsle eller skrollehjulet</p>
        </div>
      </div>

      <div className={styles.pin}>
        <img src="/images/pin.svg" alt="Picker" />
      </div>

      <div className={styles.footer}>
        <div className={styles["footer-inner"]}>
          <Button
            width="full"
            size="large"
            onClick={handlePlacePin}
            disabled={!hasLocaton}
          >
            Plasser innspel
          </Button>
          <Button size="small" color="white" onClick={closePicker}>
            Avbryt
          </Button>
        </div>
      </div>
    </div>
  );
};
